import React, {Component} from "react";
import { database } from './firebase';
import moment from 'moment';
import {Link} from "react-router-dom";

class GetLastMessage extends Component {
    constructor(props) {
        super(props);
        this.state={
          last_message:'',
          last_time:'',
          unread: 0,
        }
    }

    componentDidMount(){
      this.getLastMsg(this.props.chat_id);
    }

    getLastMsg(chat_id){
        var lmsg='';
        var ltime='';
        var unreadUsers=[];
       
        const query = database.ref(this.props.app_name+'_chats/'+chat_id)
                      .orderByKey()
                      .limitToLast(1);

        
        query.once("value").then((snapshot) => {
        var unread=0; var loopcount=1;
        var data = snapshot.val();
        var len= (data) ? Object.keys(data).length : 0;
        
        snapshot.forEach((message) => {
      
            lmsg = message.val().text;
            if(message.val().is_image === true){
              this.setState({'last_message':'file sent'});
            }else{
              this.setState({'last_message':lmsg});
            }

            if( message.val().isRead ){
                if(  message.val().isRead==='unread' && localStorage.getItem('userid') != message.val().userId){
                  unread++;
                }
            }

            var ldate= moment(message.val().date).format('DD/MM/YY');
            
            this.setState({'last_time':ldate, 'unread' : unread});
         });
        });
    }

    
    render() {
        return (
          <>
          { (this.state.last_message.length) > 0 ?
          <li className="ba-single-transaction style-two" style={{marginBottom:0}} key={Math.random()}>
              <div className="thumb">
                  <Link to={'/chat/'+this.props.id} >
                      <img src={this.props.profile_image} alt="img" />
                  </Link>
              </div>
              <div className="details">
                  <Link to={'/chat/'+this.props.id} >
                      <div>
                          <strong className="text-overflow">{this.props.full_name}</strong>
                          <small className="float-right">{this.state.last_time}</small>
                      </div>
                      <div>
                        <small>{this.state.last_message.substring(0, 90)} </small>    
                      </div>
                  </Link>    
              </div>
          </li> : ''}
        </>
      )}
    
}

export default GetLastMessage;